import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'nominas/subtipos-de-nominas';

/**
 * GET Subtipos de Nominas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSubtiposNominas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Subtipo de Nomina
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSubtipoNomina = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
